import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 py-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Trends"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold fs-7" }, "Latest trends")
  ])
], -1)
const _hoisted_2 = { class: "card-body d-flex flex-column" }
const _hoisted_3 = { class: "mt-5" }
const _hoisted_4 = { class: "d-flex flex-stack mb-5" }
const _hoisted_5 = { class: "d-flex align-items-center me-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label bg-light" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar-check fs-2x text-info" })
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Submitted")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-muted fw-bold mt-1" }, " Submitted Applicants ", -1)
const _hoisted_9 = { class: "badge badge-light fw-bold py-4 px-3" }
const _hoisted_10 = { class: "d-flex flex-stack mb-5" }
const _hoisted_11 = { class: "d-flex align-items-center me-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label bg-light" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2-square fs-2x text-success" })
  ])
], -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Approved")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-muted fw-bold mt-1" }, " Approved Applicants ", -1)
const _hoisted_15 = { class: "badge badge-light fw-bold py-4 px-3" }
const _hoisted_16 = { class: "d-flex flex-stack" }
const _hoisted_17 = { class: "d-flex align-items-center me-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label bg-light" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-circle-square fs-2x text-primary" })
  ])
], -1)
const _hoisted_19 = { class: "py-1" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Declined")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-muted fw-bold mt-1" }, "Declined Checks", -1)
const _hoisted_22 = { class: "badge badge-light fw-bold py-4 px-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_apexchart, {
        ref: "trendChart",
        class: "mixed-widget-5-chart card-rounded-top",
        options: _ctx.chartOptions,
        series: _ctx.series,
        type: "area",
        height: _ctx.chartHeight
      }, null, 8, ["options", "series", "height"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, {
                to: { name: 'customer-verifications' },
                class: "fs-6 text-gray-800 text-hover-primary fw-bolder"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _hoisted_8
            ])
          ]),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.arraySum(_ctx.store.getters.getCustomerDashboard.invited)), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, {
                to: {
                  name: 'customer-verifications',
                  params: { progressStatus: 'approved' },
                },
                class: "fs-6 text-gray-800 text-hover-primary fw-bolder"
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }),
              _hoisted_14
            ])
          ]),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.arraySum(_ctx.store.getters.getCustomerDashboard.approved)), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_router_link, {
                to: {
                  name: 'customer-verifications',
                  params: { progressStatus: 'declined' },
                },
                class: "fs-6 text-gray-800 text-hover-primary fw-bolder"
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              }),
              _hoisted_21
            ])
          ]),
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.arraySum(_ctx.store.getters.getCustomerDashboard.declined)), 1)
        ])
      ])
    ])
  ], 2))
}